import React, { useEffect, useState } from "react"
import PropTypes from "prop-types";
import { Row, Col, Card } from "reactstrap"

import profileImg from "assets/images/profile-img.png"
import { withTranslation } from "react-i18next"
import { viewProfile, listSurvey } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import checkType from "helpers/jwt-token-access/checkType";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { UncontrolledTooltip } from 'reactstrap'
import toastr from "toastr";


const WelcomeComp = props => {
  const dispatch = useDispatch();
  const { loading } = useSelector(state => ({
    loading: state?.Survey?.loading
  }));
  const [profileData, setProfileData] = useState("");
  const [surveyData, SetSurveyData] = useState([]);

  useEffect(() => {
    if (checkType() == "participant") {
      dispatch(viewProfile('survey/participant/auth/me', (res) => {
        setProfileData(res?.data)
      }));
    }

  }, [])

  const handleCopy = () => {
    toastr.success(props.t("Copied!!"))
  };

  const fetchSurveyData = () => {
    dispatch(listSurvey("participant", (res) => {
      if (res?.status === 'success') {
        SetSurveyData(res?.data)
      }
    }))
  }
  useEffect(() => {
    fetchSurveyData()
  }, []);


  return (
    <React.Fragment>
      <Card className="participant-detials-main participant-detials-main-new">
        <Row>
          <Col xs="12">
            <h3>{props.t("Score Status")}:</h3>
            {
              loading 
                ?
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                :
                <div className="participant-detials-inner">
                  <div>
                    {
                      surveyData?.survey_status == 'pending' || surveyData?.survey_status == 'in-progress'
                        ?
                        <span className="participant-detials-pendingg"><i className="bx bx-x"></i> {props.t("Complete Your Survey")} </span>
                        :
                        surveyData?.survey_status 
                        ?
                        <span className="participant-detials-completedd"><i className="bx bx-check-circle"></i> {props.t("Self Survey Completed")}</span>
                        :
                        ""
                    }
                  </div>
                  {/* <div className="d-flex mt-3">
                    <h5 className="participant-detials-h1">{props.t("Username")}:</h5>
                    <UncontrolledTooltip placement="top" target="userCopy">
                      {props.t("Click to Copy")}
                    </UncontrolledTooltip>
                    <CopyToClipboard id="userCopy" text={profileData?.username} onCopy={handleCopy}>
                      <span style={{ marginLeft: "12px", fontSize: "15px", cursor: "pointer" }}><b>{profileData?.username}</b></span>
                    </CopyToClipboard>
                  </div>
                  <div className="mt-2 d-flex">
                    <h5 className="participant-detials-h1">{props.t("Password")}:</h5>
                    <UncontrolledTooltip placement="top" target="passwordCopy">
                      {props.t("Click to Copy")}
                    </UncontrolledTooltip>
                    <CopyToClipboard id="passwordCopy" text={profileData?.password} onCopy={handleCopy}>
                      <span style={{ marginLeft: "12px", fontSize: "15px", cursor: "pointer" }}><b>{profileData?.password}</b></span>
                    </CopyToClipboard>
                  </div> */}
  
              </div>

            }

          </Col>
        </Row>
      </Card>
    </React.Fragment>
  )
}
// export default WelcomeComp

WelcomeComp.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(WelcomeComp);
